import {Component, OnDestroy, OnInit} from '@angular/core';
import Swal from 'sweetalert2';
import {AccessService} from '../services/access.service';
import {DataManagementService} from '../services/data-management.service';
import {Constants} from '../constants';
import {Router} from '@angular/router';
import {EpasUtilService} from '../services/epas-util.service';

@Component({
    selector: 'app-feedback-form',
    templateUrl: './feedback-form.component.html',
    styleUrls: ['./feedback-form.component.css']
})
export class FeedbackFormComponent implements OnInit, OnDestroy {
    errorMessage: string = undefined;
    studentId;
    termId;
    questions;
    selectUndefinedOptionValue: undefined;
    activeRoundLink: string;
    activeRound: string;
    route: string;
    timer;
    isAlreadySubmitted;
    isUniversityAllotted;
    isDataFetched;

    constructor(private accessService: AccessService,
                private dmService: DataManagementService,
                private utilService: EpasUtilService,
                private router: Router) {
    }

    getNextRouterLink() {
        if (JSON.parse(localStorage.getItem('epas_user')) !== undefined &&
            JSON.parse(localStorage.getItem('epas_user')).hasOwnProperty('term') &&
            JSON.parse(localStorage.getItem('epas_user')).term !== null) {
            const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
            this.utilService.refreshTerm(studentId).subscribe(
                details => {
                    this.utilService.term = {rounds: details.data.rounds};
                    this.utilService.term.currentTime = details.data.current_time;
                    this.utilService.term.registration_start_time = details.data.term.registration_start_time;
                    this.utilService.term.registration_end_time = details.data.term.registration_end_time;
                    this.activeRoundLink = this.utilService.getNextActiveRoundRouterLink().split('#')[0];
                    this.activeRound = this.utilService.getNextActiveRoundRouterLink().split('#')[1];
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                });
        }
    }

    getQuestions() {
        this.dmService.javaGetDataCallByParameter(Constants.FEEDBACK, this.studentId + '/' + this.termId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.isDataFetched = true;
                        if (response.data.university_allotted !== true) {
                            this.isUniversityAllotted = false;
                            this.errorMessage = 'You can\'t submit the feedback because university is not allotted';
                        } else if (response.data.feedback_submitted === true) {
                            this.isAlreadySubmitted = true;
                            this.errorMessage = 'Thank you, you have already submitted the feedback';
                        } else {
                            this.questions = response.data.questions;
                            if (this.questions.length === 0) {
                                this.errorMessage = 'There is no data available for Feedback.';
                            }
                        }
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message')) {
                            this.errorMessage = response.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team.';
                        }
                    }
                    console.log(this.errorMessage);
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    submitFeedback() {
        const that = this;
        let uploadResponse;
        const finalData = {
            outgoing_student_id: this.studentId,
            outgoing_term_id: this.termId,
            feedback_input: []
        };
        for (let i = 0; i < this.questions.length; i++) {
            const obj = this.questions[i];
            if (obj.answer_select_option_id === undefined) {
                Swal({
                    title: 'Required',
                    type: 'warning',
                    text: 'All fields are required.',
                    confirmButtonClass: 'btn btn-outline-success rounded-0',
                    confirmButtonColor: '#5cb85c',
                    showCancelButton: false,
                    showConfirmButton: true,
                }).then(function (res) {
                }, function (timer) {
                });
                return;
            }
            finalData.feedback_input.push({
                question_id: obj.question_id,
                select_option_id: parseInt(obj.answer_select_option_id, 10)
            });
        }
        console.log('finalData: ' + JSON.stringify(finalData));
        Swal({
            title: 'Confirm',
            type: 'question',
            text: 'Are you sure to submit Feedback?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(finalData, Constants.FEEDBACK).subscribe(data => {
                        uploadResponse = data;
                        resolve(uploadResponse);
                    }, error => {
                        uploadResponse = error;
                        reject(uploadResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (uploadResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                        that.router.navigate(['feedback']));
                    if (uploadResponse.hasOwnProperty('message')) {
                        Swal({
                            title: 'Success', type: 'success', html: uploadResponse.message,
                        });
                    } else {
                        Swal({title: 'Success', type: 'success', html: '<p>Successfully submitted the feedback.</p>'});
                    }
                } else if (uploadResponse.status === 'fail') {
                    if (uploadResponse.hasOwnProperty('message')) {
                        Swal({type: 'error', title: 'Fail', html: uploadResponse.message});
                    } else {
                        Swal({type: 'error', title: 'Fail', text: 'Unable to submit the feedback, Please contact support team.'});
                    }
                }
            }
        }).catch(errors => {
            Swal({type: 'error', title: 'Fail', text: 'Server Error: ' + errors.message});
        });
    }

    ngOnInit() {
        this.isUniversityAllotted = true;
        this.studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
        this.termId = JSON.parse(localStorage.getItem('epas_user')).term.outgoing_term_id;
        if (JSON.parse(localStorage.getItem('epas_user')) !== undefined && JSON.parse(localStorage.getItem('epas_user')).term !== null &&
            JSON.parse(localStorage.getItem('epas_user')).term !== undefined) {
          this.getNextRouterLink();
          this.timer = setInterval(() => {
            this.getNextRouterLink();
          }, 30000);
        }
        this.getQuestions();
    }

    ngOnDestroy() {
        clearInterval(this.timer);
    }

}
